<template>
  <div class="sidebar-box mt-6 p-1">
    <h6 class="mb-3 p-2" data-toggle="collapse" data-target="#feature-filter">
      {{ $t('filter.feature.title') }}
      <i class="bi bi-arrow-down-circle"></i>
    </h6>

    <div id="feature-filter" class="collapse p-2 show">
      <template v-for="feature in features">


        <div class="my-2" v-if="feature.feature_attributes.length > 0">
          <label class="cursor-pointer" data-toggle="collapse" :data-target="`#feature-filter-${feature.id}`"
                 data-v-68ac1b1a="">{{ feature.name }}</label>
          <i class="bi bi-chevron-left mr-1 text-dark" data-toggle="collapse"
             :data-target="`#feature-filter-${feature.id}`"></i>
        </div>


        <div class="collapse feature-height mr-2" :id="`feature-filter-${feature.id}`">

          <template v-if="feature.type == 'date'">

            <FeatureDateFilter :pageName="pageName" :feature="feature"/>

          </template>
          <template v-else>
            <div class="container">
              <label for="search" v-t="`filter.feature.search_input`"> </label>
              <input id="search" type="text" v-model="searchWord" class="form-control mb-2">
            </div>

            <div class="form-group form-check" v-for="featureAttribute in filteredFilters(feature.feature_attributes)">
              <m-a target="_blank" class="text-decoration-none text-dark"
                   :href="{name:pageName,query:{features:featureAttribute.id}}">
                {{ featureAttribute.value }}
              </m-a>
            </div>
          </template>
        </div>

      </template>

    </div>


  </div>
</template>

<script>
import mA from '../../../Tags/A.vue'
import DatePicker from "vue3-persian-datetime-picker";
import FeatureDateFilter from './FilterFeatureComponents/FeatureDateFilter.vue'

export default {
  name: "FilterFeature",
  components: {FeatureDateFilter, mA, DatePicker,},
  props: {
    features: {
      default: []
    },
    pageName: {
      default: 'Products'
    }
  },
  data() {
    return {
      searchWord: ''
    }
  },
  methods: {
    filteredFilters(features) {
      if (this.searchWord.length == 0) return features

      return features.filter(item => {
        return item.value.indexOf(this.searchWord) > -1
      })
    }
  },
  async mounted() {

  },
}
</script>

<style scoped>

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

.feature-height {
  max-height: 360px;
  overflow-y: auto;
}

.cursor-pointer {
  cursor: pointer;
}
</style>